import React from 'react'

const ModuleDisplayPassword = ({ value }) => {
    return (
        <>************</>
    )
}

export default ModuleDisplayPassword